/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Endebeschaftigungmeldung2Inputs */



/**

* @param {_Field_Endebeschaftigungmeldung2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_endebeschaftigungmeldung2 = /** @type {((inputs?: _Field_Endebeschaftigungmeldung2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Endebeschaftigungmeldung2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Ende")
});
export { _field_endebeschaftigungmeldung2 as "_field_endeBeschaftigungMeldung" }